if (typeof window.SealSubs !== 'undefined' && typeof window.SealSubs.refresh === 'function') {
  window.SealSubs.refresh();
}

function setOfferLevel(section, totalQuantity) {
  if (!section || !totalQuantity) return;
  let offers = section.querySelectorAll('.offer-text');
  if (!offers) return;
  offers.forEach(offer => {
    offer.classList.remove('active');
  });

  let activeOffer = Array.from(offers).find(offer => offer.dataset.threshold > totalQuantity);

  activeOffer ? activeOffer.classList.add('active') : offers[offers.length - 1].classList.add('active');
}
function setFeaturedPrice(section) {
  if (!section) return;
  let atc = section.querySelector('.product-form__submit');

  var totalQuantity = 0;
  var totalPrice = 0;
  var totalSubscriptionPrice = 0;
  $(section).find('.quantity__input').each(function () {
    totalQuantity += parseInt($(this).val());
    totalPrice += parseInt($(this).val() * $(this).data('normal-price'));
    totalSubscriptionPrice += parseInt($(this).val() * $(this).data('subscription-price'));
  });


  setOfferLevel(section, totalQuantity);
  // 1. get threshold quantities for each offer
  const offers = Array.from(section.querySelectorAll('.offer-text'));

  // 2. filter out all offers whose threshold quantity is less than total quantity
  const applicableOffers = offers.filter(offer => {
    const threshold = parseInt(offer.dataset.threshold);
    return threshold <= totalQuantity;
  });

  // 3. get the offer with highest threshold quantity
  const bestOffer = applicableOffers.reduce((prev, current) => {
    return (parseInt(prev.dataset.threshold) > parseInt(current.dataset.threshold)) ? prev : current;
  }, applicableOffers[0]);

  // 4. get discount amount for that offer
  const discountAmount = bestOffer ? parseFloat(bestOffer.dataset.discountAmount) * 100 : 0;

  (atc && totalQuantity == 0) ? atc.setAttribute('disabled', '') : atc.removeAttribute('disabled');

  let totalEm = section.querySelector('.featured-total');
  // if (totalEm) totalEm.textContent = ((totalQuantity * totalEm.dataset.price) / 100).toFixed(2);

  let selectedOption = section.querySelector('.sls-option[type=radio]:checked');
  if (selectedOption && totalEm) {
    if (selectedOption.dataset.type == 'subscription') {
      totalEm.textContent = ((totalSubscriptionPrice - discountAmount) / 100).toFixed(2);
    } else {
      totalEm.textContent = ((totalPrice - discountAmount) / 100).toFixed(2);
    }
  }


}

// This event will be fired whenever a different subscription option is selected
document.addEventListener('sealsubs:price_update', function (e) {
  let em = e.detail.element;
  let section = em.closest('.product__info-container');
  if (!section) return;

  let totalEm = section.querySelector('.featured-total');
  if (totalEm) {
    // totalEm.dataset.price = e.detail.price;
    setFeaturedPrice(section);
  }

  let oneTimeUnitPrice = em.dataset.unitPrice;
  let oneTimeElement = em.querySelector('.sls-one-time-price');
  oneTimeElement && (oneTimeElement.dataset.unitPrice = oneTimeUnitPrice);

  let currencySymbol = em.dataset.currencySymbol;
  let servingsPerProduct = parseInt(em.dataset.servingsPerProduct);
  let pricePerServingText = em.dataset.pricePerServingText;
  let displayPrice = null;
  if (currencySymbol && servingsPerProduct && pricePerServingText) {
    let calculated = (e.detail.price / servingsPerProduct / 100).toFixed(2);
    calculated ? displayPrice = `${currencySymbol}${calculated}${pricePerServingText}` : null;
  }

  let selectedOption = em.querySelector('.sls-option[type=radio]:checked');
  let selectedOptionContainer = selectedOption && selectedOption.closest('.sls-option-container');
  let selectedPriceContainer = selectedOptionContainer && selectedOptionContainer.querySelector('.sls-price-container');
  selectedPriceContainer && displayPrice && (selectedPriceContainer.dataset.unitPrice = displayPrice);
});

// Update the featured price when the quantity is changed
$('.abz_feature_product .quantity__input').change(function (e) {
  let section = e.target.closest('.product__info-container');
  let mainElm = e.target.closest('quantity-input');

  if (mainElm) {
    // (e.target.value == 0) ? mainElm.classList.add('zero') : mainElm.classList.remove('zero');
  }
  setFeaturedPrice(section);
});

// Update the featured price when the page is loaded by dispatching a change event for 1st quantity input of every featured product section
document.querySelectorAll('.abz_feature_product .product__info-container').forEach(section => {
  let featuredQuantity = section.querySelector('.quantity__input');
  featuredQuantity && featuredQuantity.dispatchEvent(new Event("change"));
})

$('.menu-drawer__menu-item').click(function () {
  $('#Details-menu-drawer-container').removeClass('menu-opening');
  $('body').removeClass(' overflow-hidden-tablet');

  $('#Details-menu-drawer-container').removeAttr('open');
  $('.header__icon--menu').attr('aria-expanded', 'false');
});


// function setSameHeightToBenefitsLists() {
//   document.querySelectorAll('.shopify-section:has(.abz-benefits-list.injected, .abz-one-time-benefits-list.injected)').forEach(section => {
//     const sameSectionBenefitsLists = section.querySelectorAll('.abz-benefits-list.injected:not(.abz-one-time-benefits-list.injected)');
//     const sameSectionOneTimeBenefitsLists = section.querySelectorAll('.abz-one-time-benefits-list.injected');

//     // 1. Check if there are multiple benefits list in the same section
//     if (sameSectionBenefitsLists && sameSectionBenefitsLists.length > 1) {
//       let maxHeight = 0;
//       sameSectionBenefitsLists.forEach(list => {
//         let listHeight = list.getBoundingClientRect().height;
//         // set the same height to all the benefits list based on the highest height
//         if (listHeight > maxHeight) {
//           maxHeight = listHeight;
//         }
//       });
//       sameSectionBenefitsLists.forEach(list => {
//         list.style.minHeight = maxHeight + 'px';
//       });
//     }

//     if (sameSectionOneTimeBenefitsLists && sameSectionOneTimeBenefitsLists.length > 1) {
//       let maxHeight = 0;
//       sameSectionOneTimeBenefitsLists.forEach(list => {
//         let listHeight = list.getBoundingClientRect().height;
//         // set the same height to all the benefits list based on the highest height
//         if (listHeight > maxHeight) {
//           maxHeight = listHeight;
//         }
//       });
//       sameSectionOneTimeBenefitsLists.forEach(list => {
//         list.style.minHeight = maxHeight + 'px';
//       });
//     }
//   });
// }

// document.addEventListener('DOMContentLoaded', setSameHeightToBenefitsLists);
// document.addEventListener('product-switcher-tab-clicked', setSameHeightToBenefitsLists);
// window.addEventListener('resize', setSameHeightToBenefitsLists);
// document.addEventListener('shopify:section:load', setSameHeightToBenefitsLists);
// document.addEventListener('shopify:section:unload', setSameHeightToBenefitsLists);

customElements.define('abz-benefits-list', class ABZBenefitsList extends HTMLElement {
  constructor() {
    super();
    this.productInfoContainer = this.closest('.product__info-container');
  }
  connectedCallback() {
    // This event will be fired for each subscription widget that gets created  
    document.addEventListener('sealsubs:subscription_widget_created', (e) => {
      // Subscription widget was created
      this.subscriptionElement = e.detail.element;
      if (!this.subscriptionElement) return;
      this.subscriptionElementContainer = this.subscriptionElement.closest('.product__info-container');
      if ((this.subscriptionElementContainer !== this.productInfoContainer) || (this.subscriptionElementContainer == null)) return;
      this.injectBenefitsList();
    });
  }

  injectBenefitsList() {
    let targetParent = this.subscriptionElement.querySelector('.sls-purchase-options-container [data-selling-plan-group-id]');
    if (!targetParent) return;
    targetParent.appendChild(this);
    this.classList.add('injected');
  }
})
customElements.define('abz-one-time-benefits-list', class ABZOneTimeBenefitsList extends HTMLElement {
  constructor() {
    super();
    this.productInfoContainer = this.closest('.product__info-container');
  }
  connectedCallback() {
    // This event will be fired for each subscription widget that gets created  
    document.addEventListener('sealsubs:subscription_widget_created', (e) => {
      // Subscription widget was created
      this.subscriptionElement = e.detail.element;
      if (!this.subscriptionElement) return;
      this.subscriptionElementContainer = this.subscriptionElement.closest('.product__info-container');
      if ((this.subscriptionElementContainer !== this.productInfoContainer) || (this.subscriptionElementContainer == null)) return;
      this.injectBenefitsList();
    });
  }

  injectBenefitsList() {
    // Target the one-time purchase option instead of subscription options
    let targetParent = this.subscriptionElement.querySelector('.sls-purchase-options-container .sls-option-container:not([data-selling-plan-group-id])');
    if (!targetParent) return;
    targetParent.appendChild(this);
    this.classList.add('injected');

  }
})





// menu-opening
//$('.menu-drawer__menu-item').click( function() { 
//   let accordion_trigger = $('.menu-opening');
//  let accordion_button = accordion_trigger.find(".header__icon--menu");
//  alert("test");

//   accordion_button.setAttribute("aria-expanded", "false");
// });

// Multi Column Slider
$('.center-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: true,
  arrows: false,
  dots: true,
  speed: 300,
  centerPadding: '20px',
  pauseOnHover: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 300,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        speed: 300,
        centerPadding: '10px',
        ltr: false
      }
    }
  ]
});


$('#toggle1').click(function () {
  if ($('#toggle1').hasClass('play')) {
    $('#toggle1').removeClass('play');
    $('#toggle1').addClass('pause');
    $('.center-slider').slick('slickPause')
  } else {
    $('#toggle1').addClass('play');
    $('#toggle1').removeClass('pause');
    $('.center-slider').slick('slickPlay')
  }
});



// Init Slick
$(".main-slider").slick({
  slidesToShow: 2,
  slidesToScroll: 2,
  infinite: true,
  dots: false,
  arrows: false,
  responsive: [
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// Testimonial Slider
$(".testimonial").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  dots: false,
  arrows: true,
  responsive: [
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// ABZ Multicolumn 1 Slider
$(".multy_image_slider").slick({
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1
});

// Featured Slider 
$(".featured_slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  dots: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// Ingredients Accordion 
// $('.video_content h5').click(function(){
//    $(this).next().slideToggle(500);
//    $(this).toggleClass('remove');
// })

/* Thumbnail Slider */
document.addEventListener("DOMContentLoaded", function () {
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    fade: true,
    asNavFor: '.slider-nav',
    prevArrow: '<button type="button" class="slick-prev custom-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18L9 12L15 6" /></svg></button>',
    nextArrow: '<button type="button" class="slick-next custom-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6L15 12L9 18" /></svg></button>'
  });

  $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    infinite: false,
    centerMode: false,
    focusOnSelect: true,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4
        }
      }
    ]
  });
});
/* End */

// Hamburger menu
let menuToggle = document.querySelector('.header__icon--menu');

if (menuToggle) {
  menuToggle.addEventListener('click', () => document.body.classList.toggle('menu-open-1'));
}

class ProductSwitcherTabs extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section');
    this.addEventListener('click', this.onTabClick.bind(this));
  }

  onTabClick(event) {
    const tab = event.target.closest('.product-switcher-tab');
    if (!tab || !this.contains(tab)) return;

    // Remove 'active' from all target parts
    this.querySelectorAll('.product-switcher-tab').forEach(t => {
      const targetId = t.getAttribute('data-target-part');
      if (targetId) {
        const target = document.getElementById(targetId);
        if (target) target.classList.remove('active');
      }
    });

    // Add 'active' to the target part for the clicked tab
    const targetId = tab.getAttribute('data-target-part');
    if (targetId) {
      const target = document.getElementById(targetId);
      if (target) target.classList.add('active');
    }


    this.refreshSlickSliders();
    // dispatch a custom event to entire document
    document.dispatchEvent(new Event('product-switcher-tab-clicked'));
  }

  refreshSlickSliders() {
    const sliders = this.section.querySelectorAll('.slick-slider');
    sliders.forEach(slider => $(slider).slick('refresh'));
  }
}

customElements.define('product-switcher-tabs', ProductSwitcherTabs);